import { AlertNew } from '..'
import type { Account, UUID } from '..'

export type Response<Ok = boolean> = Ok extends true
    ? {
          ok: Ok
          access_token: string
          bot_user_id: string
          scope: string
          enterprise: string | null
          team: { id: string; name: string }
          incoming_webhook: {
              channel: string
              channel_id: string
              configuration_url: string
              url: string
          }
      }
    : {
          ok: Ok
          error: string
      }

// See https://api.slack.com/events/app_uninstalled
export type UninstallRequestBody = {
    token: string
    team_id: string
    api_app_id: string
    event: {
        type: 'app_uninstalled'
        event_ts: string
    }
    type: 'event_callback'
    event_id: string
    event_time: number
}

export type State = {
    slackConnectState?: UUID
    userId?: number
    isDomainSpecificConnection?: boolean
    accountId?: Account.ID
}

export interface ComplexMessage {
    attachments: {
        title?: string
        title_link?: string
        color?: string
        image_url?: string
        mrkdwn_in?: string[]
        text?: string
        author_name?: string
        footer?: string
        fields?: { title: string; value: string; short: boolean }[]
    }[]
}

/** Block Kit message; `text` is the notification fallback. */
export interface BlocksMessage {
    text: string
    blocks: { type: string; [key: string]: unknown }[]
}

export type Message = ComplexMessage | BlocksMessage | string

export const MsgType = {
    ...AlertNew.AlertType,
    ImprovementReminder: 'improvement_reminder',
    RawMessage: 'raw_message',
} as const
export type MsgType = (typeof MsgType)[keyof typeof MsgType]

type AuthCommonFields<IsDomainSpecific extends boolean | undefined> = {
    access_token: string
    scope?: string
    connected_at?: string
    channel_id: string
    url: string
    channel_name: string
    user_id: number
    bot_user_id?: string
    workspace_id: IsDomainSpecific extends true ? string : string | undefined
    workspace_name: IsDomainSpecific extends true ? string : string | undefined
    is_domain_specific_connection?: IsDomainSpecific
}

type DomainSpecificConnectionOAuth = AuthCommonFields<true>
type GeneralConnectionOAuth = AuthCommonFields<false | undefined>

export type OAuth = DomainSpecificConnectionOAuth | GeneralConnectionOAuth

export namespace SaveOAuth {
    export type CommonArgs = {
        code: string | null
        isQueryError: boolean
        userId: number
    }

    type DomainSpecificConnectionArgs = {
        accountId: Account.ID
        isDomainSpecificConnection: true
    }

    type GeneralConnectionArgs = {
        accountId?: never
        isDomainSpecificConnection: false
    }

    export type Args = CommonArgs & (DomainSpecificConnectionArgs | GeneralConnectionArgs)
}
